import React from 'react'
import {Redirect} from 'react-router-dom'
import {usePageData} from '../../_metronic/layout/core'
import {PAGE_PERMISSION} from '../modules/roles/constant/role-default'
import {ReportDetail} from '../modules/roles/models/role-model'

const ActivePageBasedRedirect = () => {
  const {
    currentUser: {activePages},
  } = usePageData()

  if (!activePages) {
    return null
  }

  const permissionsOrder = [
    {permission: PAGE_PERMISSION.Dashboard, route: '/dashboard'},
    {permission: PAGE_PERMISSION.Users, route: '/user'},
    {permission: PAGE_PERMISSION.Roles, route: '/role'},
    {permission: PAGE_PERMISSION.Audit, route: '/audit'},
  ]

  for (let {permission, route} of permissionsOrder) {
    if (activePages.some((page) => page.name === permission)) {
      return <Redirect to={route} />
    }
  }

  return null
}

export default ActivePageBasedRedirect
